import authorizedAPIInstance from '@/api/authorizedAPI';
import type { AssetHierarchyResponse } from '../utils/assetHierarchy.types';

export const getAssetHierarchyAPI =
  async (): Promise<AssetHierarchyResponse> => {
    const { data } = await authorizedAPIInstance.get<AssetHierarchyResponse>(
      '/assets/hierarchy',
      {}
    );
    const responseData: AssetHierarchyResponse = data;
    return responseData;
  };
